<script>
	/* eslint-env gtag */
	import '@ctm/compass/style.css';
	import '../global.css';
	import '$lib/http/interceptors';
	// import { page } from '$app/stores';
	import { trackingSetup, setTrackingIdentity } from '$lib/helpers/tracking';
	import { signedInUser } from '@ctm/auth/store';

	trackingSetup();
	$: if ($signedInUser) setTrackingIdentity($signedInUser);

	// FIXME: do we still use gtag? the script is missing from
	// src/app.html so this code is never executed
	//
	// if (typeof gtag !== 'undefined') {
	// 	let pageTitle = $page.name.substring(state.name.lastIndexOf('.') + 1);
	// 	pageTitle = pageTitle.charAt(0).toUpperCase() + pageTitle.substring(1);

	// 	gtag('config', 'UA-128266597-1', {
	// 		page_title: `${document.title} - ${pageTitle}`,
	// 		page_path: `/${state.route}`
	// 	});
	// }
</script>

<slot />
